import React, { useState, useRef } from "react";
import axios from "axios";
import { main_link } from "../Connection/Connection";

import { Toast } from "primereact/toast";
import { Button } from "react-bootstrap";
//
//
const AddNewCustomer = (props) => {
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);

  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [star, setStar] = useState(false);
  const [note, setNote] = useState();
  const [address, setAddress] = useState();
  const [dob, setDob] = useState();

  const [msg, setMsg] = useState();
  const [error, setError] = useState(false);

  const setCounter = props.setCounter;
  const counter = props.counter;

  const add = async () => {
    //

    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user["encrypted_id"];

    setLoading(true);
    setMsg("");
    setError(false);

    try {
      const response = await axios.post(main_link + "addCustomer", {
        name,
        email,
        phone,
        star,
        note,
        address,
        dob,
        user_id,
      });

      setLoading(false);
      setMsg(response.data);

      if (response.data.message == "Added Successfully.") {
        document.getElementById("addCustomerForm").reset();
        $("#add-customer").modal("hide");
        setName("");
        setPhone("");
        setEmail("");
        setStar(false);
        setNote("");
        setAddress("");
        setDob("");
        setCounter(counter + 1);

        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Added Successfully.",
        });
      } else {
      }
    } catch (error) {
      setLoading(false);
      let errorMessage = "";
      Object.values(error.response.data.errors).forEach((errorArray) => {
        errorArray.forEach((error) => {
          errorMessage += error + "\n";
        });
      });
      setMsg(errorMessage);
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: errorMessage,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Toast ref={toast} />
      <form id="addCustomerForm">
        <div className="modal fade" id="add-customer" data-backdrop="static">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title text-primary">Add Customer</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="inputName">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Full Name"
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="inputEmail">Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        id="inputEmail"
                        placeholder="Email Address"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        placeholder="Phone Number"
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="dob">Birth Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="dob"
                        placeholder="Customer Address"
                        onChange={(e) => setDob(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="custAddress">Customer Address</label>
                      <input
                        type="email"
                        className="form-control"
                        id="custAddress"
                        placeholder="Customer Address"
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="star">Star ?</label>
                      <input
                        type="checkbox"
                        id="star"
                        value={false}
                        onChange={(e) => setStar(e.target.checked)}
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: "25px",
                          marginLeft: "30px",
                        }} // Adjust the size here
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="note">Notes</label>
                      <textarea
                        className="form-control"
                        rows={3}
                        placeholder="Any Note ..."
                        defaultValue={""}
                        id="note"
                        onChange={(e) => setNote(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <Button
                  type="button"
                  className="btn btn-default bg-white"
                  data-dismiss="modal"
                >
                  Close
                </Button>
                {!loading && (
                  <Button onClick={add} className="btn btn-primary">
                    Submit
                  </Button>
                )}
                {loading && (
                  <Button className="btn btn-primary" disabled="disabled">
                    Loading ...
                  </Button>
                )}
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
      </form>{" "}
    </>
  );
};

export default AddNewCustomer;
